import React from 'react';
import PropTypes from 'prop-types';

import '../contentPage/ContentPage.sass';

import {injectIntl} from 'react-intl';

import ChannelLink from '../channelUtils/ChannelLink';
import Button from '../../components/button/Button';
import {Helmet} from 'react-helmet';
const NOT_FOUND = 'not-found';
const SERVICE_UNAVAILABLE = 'service-unavailable';

@injectIntl
export default class ErrorPage extends React.PureComponent {
  static notFound = NOT_FOUND;
  static serviceUnavailable = SERVICE_UNAVAILABLE;

  static propTypes = {
    type: PropTypes.oneOf([NOT_FOUND, SERVICE_UNAVAILABLE])
  };

  static defaultProps = {
    type: NOT_FOUND
  };

  openIntercom = (evt) => {
    evt.preventDefault();

    if (window.Intercom) {
      window.Intercom('show');
    }
  }

  render() {
    const {intl, type} = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>{type === NOT_FOUND
            ? intl.formatMessage({id: 'page.error.not-found-title'})
            : intl.formatMessage({id: 'page.error.unexpected-title'})
          }</title>
        </Helmet>
        <div className="page-info">
          <div className="text-block">
            <h1>{type === NOT_FOUND
              ? intl.formatMessage({id: 'page.error.not-found'})
              : intl.formatMessage({id: 'page.error.unexpected'})
            }</h1>
          </div>

          <div className="text-block">
            <p>{intl.formatMessage({id: 'page.error.contact-us'})}:</p>

            <ul>
              <li>
                <a
                  href="#"
                  onClick={(evt) => this.openIntercom(evt)}
                >
                  {intl.formatMessage({id: 'page.error.chat'})}
                </a>
              </li>
              <li>E-mail: <a href="mailto:support@boosthive.eu">support@boosthive.eu</a></li>
            </ul>

            <br/>

            <ChannelLink to="/">
              <Button filled>{intl.formatMessage({id: 'page.error.back'})}</Button>
            </ChannelLink>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/errorPage/ErrorPage.js